import { createPinia } from 'pinia'

// Création de l'instance Pinia
const pinia = createPinia()

export default pinia

